import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index/index'
import callDriver from '@/views/callDriver/index' // 呼叫司机
import advertises from '@/views/advertises/index' // 公司简介 + 提交报名信息（洪师傅）
import advertiseslb from '@/views/advertises/lb' // 公司简介 + 提交报名信息（萝卜代驾）
import recommend from '@/views/recommend/index' // 绑定邀请码（提现、核销订单）
import tixian from '@/views/recommend/tixian'
import reward from '@/views/recommend/reward' // 提现到微信
import invitation from '@/views/invitation/invitation' // 邀请码 邀请新用户
import coupon from '@/views/coupon/index' // 手机号领取优惠券
import store from '../store/store'
import prodetail from '@/views/shopmall/prodetail'
import confirm from '@/views/shopmall/confirm' // 确认订单
import shopcenter from '@/views/shopcenter/index' // 1、个人中心
import shopbind from '@/views/shopcenter/bind' // 登录页【绑定账号】
import shoporder from '@/views/shoporder/index' // 订单列表
import shoporderDetail from '@/views/shoporder/detail' // 订单详情
import evaluate from '@/views/evaluate/index' // 评价
import trip from '@/views/trip/index' // 行程记录
import shopmall from '@/views/shopmall/index' // 积分商城
import shopinte from '@/views/shopinte/index' // 积分兑换
import shopcard from '@/views/shopcard/index' // 我的卡券
import gift from '@/views/shopcard/gift' // 我的礼品
import address from '@/views/address/address' // 收费标准
import hotline from '@/views/hotline/index' // 客服热线
import newHotLine from '@/views/hotline/newHotLine' // 新版 客服热线
import agreement from '@/views/agreement/index' // 服务协议
import company from '@/views/company/list' // 公司所在地区
Vue.use(Router)
if (sessionStorage.getItem('token')) {
    store.commit('set_token', sessionStorage.getItem('token'))
}
const router = new Router({
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    // 跳转返回顶部
    scrollBehavior(to, from, saveTop) {
        if (saveTop) {
            return saveTop
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/address',
            name: 'address',
            component: address,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/advertises',
            name: 'advertises',
            component: advertises,
            meta: {
                title: ''
            }
        },
        {
            path: '/advertiseslb',
            name: 'advertiseslb',
            component: advertiseslb,
            meta: {
                title: ''
            }
        },
        {
            path: '/recommend',
            name: 'recommend',
            component: recommend,
            meta: {
                title: ''
            }
        },
        {
            path: '/tixian',
            name: 'tixian',
            component: tixian,
            meta: {
                title: ''
            }
        },
        {
            path: '/reward',
            name: 'reward',
            component: reward,
            meta: {
                title: ''
            }
        },
        {
            path: '/invitation',
            name: 'invitation',
            component: invitation,
            meta: {
                title: ''
            }
        },
        {
            path: '/trip',
            name: 'trip',
            component: trip,
            meta: {
                title: ''
            }
        },
        {
            path: '/evaluate',
            name: 'evaluate',
            component: evaluate,
            meta: {
                title: '',
                index: 2
            }
        },
        {
            path: '/callDriver',
            name: 'callDriver',
            component: callDriver,
            meta: {
                title: ''
            }
        },
        {
            path: '/hotline',
            name: 'hotline',
            component: hotline,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/newHotLine',
            name: 'NewHotLine',
            component: newHotLine,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/coupon',
            name: 'coupon',
            component: coupon,
            meta: {
                title: ''
            }
        },
        {
            path: '/shopcenter',
            name: 'shopcenter',
            component: shopcenter,
            meta: {
                title: '',
                index: 0
            }
        },
        {
            path: '/shopcard',
            name: 'shopcard',
            component: shopcard,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/shoporder',
            name: 'shoporder',
            component: shoporder,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/shoporderDetail',
            name: 'shoporderDetail',
            component: shoporderDetail,
            meta: {
                title: '',
                index: 2
            }
        },
        {
            path: '/shopinte',
            name: 'shopinte',
            component: shopinte,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/shopbind',
            name: 'shopbind',
            component: shopbind,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/shopmall',
            name: 'shopmall',
            component: shopmall,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/prodetail',
            name: 'prodetail',
            component: prodetail,
            meta: {
                title: '',
                index: 2
            }
        },
        {
            path: '/confirm',
            name: 'confirm',
            component: confirm,
            meta: {
                title: '',
                index: 3
            }
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: agreement,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/gift',
            name: 'gift',
            component: gift,
            meta: {
                title: '',
                index: 1
            }
        },
        {
            path: '/company',
            name: 'Company',
            component: company
        },
        {
            path: '/complaint',
            name: 'Complaint',
            component: (resolve) => require(['@/views/complain/complaint'], resolve)
        },
        {
            path: '/complainList',
            name: 'ComplainList',
            component: (resolve) => require(['@/views/complain/list'], resolve)
        },
        {
            path: '/complainDetail',
            name: 'ComplainDetail',
            component: (resolve) => require(['@/views/complain/detail'], resolve)
        },
        {
            path: '/driverSignInfo',
            name: 'DriverSignInfo',
            meta: { title: '司机入职' },
            component: (resolve) => require(['@/views/driver/signInfo'], resolve)
        }
    ]
})
// router.beforeEach((to,from,next)=>{
//   // console.log(to);
//   // console.log(from);
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next();
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js